import { createThunk, model, Model, view } from 'mst-collection';
import { getRoot, types } from 'mobx-state-tree';

import { Api, schemas } from '@api';
import { useRoot } from '../useRoot';
import { RootModelType } from '../RootModel';
import { ConversationListModel } from './ConversationListModel';
import { SearchedConversationListModel } from './SearchedConversationListModel';
import { Conversation } from './ConversationModel';

export class Chats extends Model({
  list: types.optional(ConversationListModel, {}),
  searched: types.optional(SearchedConversationListModel, {}),
  newCount: 0,
}) {
  get hasNewMessages() {
    return this.newCount > 0;
  }

  get formattedNewCount() {
    return this.newCount > 9 ? '9+' : `${this.newCount}`;
  }

  decreaseNewCount() {
    this.newCount = Math.max(this.newCount - 1, 0);
  }

  setNewCount(value: number) {
    this.newCount = value;
  }

  fetchCount = createThunk(() => {
    return async function fetchCount(this: Chats) {
      const res = await Api.Messaging.getCountOfNewMessages();

      this.setNewCount(res.data.count);
    };
  });

  fetchById = createThunk((id: number) => {
    return async function fetchById(flow) {
      const res = await Api.Messaging.getConversationById({ id });

      flow.merge(res.data, schemas.ConversationSchema);
    };
  });

  @view
  getById(id: number): Conversation | undefined {
    return getRoot<RootModelType>(this).entities.conversations.get(
      id,
    );
  }
}

export const ChatsModel = model(Chats);

export function useChatsModel() {
  const root = useRoot();

  return root.chats;
}
